import Asset from '../../asset';
import GenericModel from '../../generic-model';
import { ConditionalPrice } from '../conditional-price';
import { SignPhoneNumberAdjustmentAsset } from './sign-phone-number-adjustment-asset';

export class SignPhoneNumberAdjustment extends GenericModel {
  archived: boolean;
  phoneNumber: string;
  examples: SignPhoneNumberAdjustmentAsset[];
  width: number;
  height: number;
  inStock: boolean;
  standard: boolean;
  textColor: string;
  foundationColor: string;
  immo: boolean;
  immoInfo: string;
  graphical: boolean;
  graphicalInfo: string;
  atelier: boolean;
  atelierInfo: string;
  installer: boolean;
  installerInfo: string;
  charge: ConditionalPrice;
  graphicsComplete: boolean;
  adminComplete: boolean;

  offlineExamples: Asset[];
}
